"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    MS_BUCKET_SIGN_API: "https://api.mostaz.app/bucket/sign"
};
